import { render, staticRenderFns } from "./Withdrawktb.vue?vue&type=template&id=88d5feba"
import script from "./Withdrawktb.vue?vue&type=script&lang=js"
export * from "./Withdrawktb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports